import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames/bind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';

import {
  ukInsightsChartFilter,
} from '../../../../data/directory/topics/capitalStructure';

import ChartSection from './ChartSection';
import ChartTimeFilters from '../../../SEO_pages/ChartFilters/ChartTimeFilters';
import Tooltip from '../../../Tooltip';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

const GBPChart = (props) => {
  const { isMainPage, extraParams, natureOfBusiness } = props;
  const [activeFilter, setActiveFilter] = useState('1y');
  const [activeType, setActiveType] = useState('count');
  const width = useSelector(({ common }) => (
    common.width
  ));

  const setTimeFilter = (value) => {
    setActiveFilter(value);
  };

  return (
    <div className={cx('gbp-chart', { main: isMainPage })}>
      <div className={Styles['gbp-chart-title']}>
        Equity Fundraising Trend (GBP)
        <Tooltip
          newIcon
          hasBigScreenDesign
          isCentered
          className={Styles['gbp-chart-title-tooltip']}
        >
          Funds raised by private companies in the UK over time.
        </Tooltip>
      </div>
      {width <= 767 && (
        <div className={Styles['gbp-chart-outer']}>
          <div className={Styles['gbp-chart-body-types']}>
            <div
              className={cx('gbp-chart-body-type', { active: activeType === 'value' })}
              onClick={() => setActiveType('value')}
            >
              Value
            </div>
            <div
              className={cx('gbp-chart-body-type', { active: activeType === 'count' })}
              onClick={() => setActiveType('count')}
            >
              Count
            </div>
          </div>
          <Tooltip
            newIcon
            hasBigScreenDesign
            isCentered
            dynamicPosition
            contentStyle={{ left: 0 }}
            className={Styles['gbp-chart-body-tooltip']}
          >
            Value shows the aggregate value of all reported investments.
            Count shows the count of reported investments.
          </Tooltip>
        </div>
      )}
      <div className={Styles['gbp-chart-body']}>
        <div className={Styles['gbp-chart-body-header']}>
          <div className={Styles['gbp-chart-body-filter']}>
            {width > 767 && (
              <>
                <div className={Styles['gbp-chart-body-types']}>
                  <div
                    className={cx('gbp-chart-body-type', { active: activeType === 'value' })}
                    onClick={() => setActiveType('value')}
                  >
                    Value
                  </div>
                  <div
                    className={cx('gbp-chart-body-type', { active: activeType === 'count' })}
                    onClick={() => setActiveType('count')}
                  >
                    Count
                  </div>
                </div>
                <Tooltip
                  newIcon
                  hasBigScreenDesign
                  isCentered
                  dynamicPosition
                  contentStyle={{ left: 0 }}
                  className={Styles['gbp-chart-body-tooltip']}
                >
                  Value shows the aggregate value of all reported investments.
                  Count shows the count of reported investments.
                </Tooltip>
              </>
            )}
            <div className={Styles['gbp-chart-body-period']}>Period:</div>
            <ChartTimeFilters
              hasBigScreenDesign
              options={ukInsightsChartFilter}
              activeFilter={activeFilter}
              setTimeFilter={setTimeFilter}
              className={cx('filters')}
            />
          </div>
          {/* <div className={Styles['gbp-chart-body-header-see-more']}>
            <Link
              to="/news/directory/uk-private-companies-insights"
            >
              See More
              <FontAwesomeIcon icon={faChevronRight} />
            </Link>
          </div> */}
        </div>
        <ChartSection
          isMainPage={isMainPage}
          extraParams={extraParams}
          activeFilter={activeFilter}
          activeType={activeType}
          natureOfBusiness={natureOfBusiness}
        />
        {/* <div className={Styles['gbp-chart-see-more']}>
          <Link
            to="/news/directory/uk-private-companies-insights"
          >
            See More
            <FontAwesomeIcon icon={faChevronRight} />
          </Link>
        </div> */}
      </div>
    </div>
  );
};

export default GBPChart;
